export interface IMenuItem {
  title: string;
  route: string;
  count?: number | null;
  element?: JSX.Element;
}

export interface IMenuItemsGroup {
  title: string;
  route: string;
  items: IMenuItem[];
}

export interface IMenuSection {
  title: string;
  items: (IMenuItem | IMenuItemsGroup)[];
}

export type SidebarItem = {
  [key: string | number]: unknown;
  text: string;
  link: string;
  count: number;
  items?: SidebarItem[];
  menuItemType: string;
};
export type SidebarHeader = {
  text: string;
  menuItemType: string;
};

export const menuItem = (title: string, route: string, count?: number | null, element?: JSX.Element): IMenuItem => ({
  title,
  route,
  count,
  element,
});

export const menuSection = (title: string, items: (IMenuItem | IMenuItemsGroup)[]): IMenuSection => ({
  title,
  items,
});

export const processGroup = (group: IMenuItem | IMenuItemsGroup) => {
  const result: IMenuItem | IMenuItemsGroup = JSON.parse(JSON.stringify(group));

  if ('items' in result && result.items) {
    result.items = result.items.map((item) => ({ ...item, route: group.route + item.route }));
  }

  return result;
};

export const processSection = (section: IMenuSection) => ({
  ...section,
  items: section.items.map((item) => processGroup(item)),
});

export const isExternalLink = (link: string): boolean =>
  link?.indexOf('https://') === 0;
